module.exports = __webpack_public_path__ + "static/media/oil-pipe-HD.373b1c1c.png";